import { useLogger } from '@booksy-com/vue-tools'
import { useDevConsole } from '@/composables/dev-console'

export interface DevLoggerReturn {
  debug: (...args: unknown[]) => void
  error: (...args: unknown[]) => void
}

const stringify = (args: unknown[]): string => {
  const message = args.length > 1 ? args : args[0]

  // shortcut: stringify arrays and objects
  if (message && typeof message === 'object') {
    return JSON.stringify(message)
  }
  return String(message)
}

export const useDevLogger = (name: string): DevLoggerReturn => {
  const logger = useLogger(name)
  const devConsole = useDevConsole()

  const debug = (...args: unknown[]): void => {
    logger.debug(...args)
    devConsole.logText(`[${name}] ${stringify(args)}`)
  }

  const error = (...args: unknown[]): void => {
    logger.error(...args)
    devConsole.logError(`[${name}] ${stringify(args)}`)
  }

  return {
    debug,
    error,
  }
}
